// extracted by mini-css-extract-plugin
module.exports = {"burger":"style_burger__1M03x","-open":"style_-open__wzgUN","inner":"style_inner__G2Fbb","box":"style_box__3VoRI"};